import { tryJsonParse } from './jsonHelper.js';
export class LocalStorageHelpers {
    static getString(key) {
        return localStorage[key];
    }
    static setString(key, value) {
        localStorage.setItem(key, value);
    }
    static getNumber(key) {
        return Number(localStorage[key]);
    }
    static setNumber(key, value) {
        localStorage.setItem(key, value.toString());
    }
    static getJson(key) {
        return tryJsonParse(localStorage[key]);
    }
    static setJson(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
}
